import { render, staticRenderFns } from "./DynamicBlockPublish.vue?vue&type=template&id=1a0db14f&scoped=true&"
import script from "./DynamicBlockPublish.vue?vue&type=script&lang=ts&"
export * from "./DynamicBlockPublish.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicBlockPublish.vue?vue&type=style&index=0&id=1a0db14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0db14f",
  null
  
)

export default component.exports